import React from "react";
import Typography from "@mui/material/Typography";

const MaxCapMarquee = () => {
  const marqueeMessage = "Please configure max cap quantity in cases.";
  return (
    <div className="marqueeDisplay marqueeDisplayD1D2">
      <Typography>{marqueeMessage}</Typography>
    </div>
  );
};

export default MaxCapMarquee;
